import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
import { CornerBrackets } from './CornerBrackets';
import { CyberButton } from './CyberButton';
import { ProjectModal } from './ProjectModal';
import { ContactModal } from './ContactModal';
interface CTASectionProps {
  onModalStateChange?: (isOpen: boolean) => void;
}
export function CTASection({
  onModalStateChange
}: CTASectionProps) {
  const {
    t
  } = useLanguage();
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  useEffect(() => {
    if (onModalStateChange) {
      onModalStateChange(isProjectModalOpen || isContactModalOpen);
    }
  }, [isProjectModalOpen, isContactModalOpen, onModalStateChange]);
  return <>
      <section className="py-32 bg-black/90 relative" data-id="element-108">
        <div className="max-w-5xl mx-auto px-4" data-id="element-109">
          <div className="relative p-16 border border-white/10 bg-dark-card overflow-hidden" data-id="element-110">
            <CornerBrackets className="scale-100" color="cyan" data-id="element-111" />

            <div className="relative z-10 text-center" data-id="element-112">
              <motion.h2 initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} className="font-cyber text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-113">
                {t.cta.title}
              </motion.h2>

              <p className="subtitle-text mb-10 max-w-xl mx-auto" data-id="element-114">
                {t.cta.subtitle}
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-115">
                <CyberButton variant="primary" onClick={() => setIsProjectModalOpen(true)} data-id="element-116">
                  {t.cta.primary.toUpperCase()}
                </CyberButton>
                <CyberButton variant="secondary" onClick={() => setIsContactModalOpen(true)} data-id="element-117">
                  {t.cta.secondary.toUpperCase()}
                </CyberButton>
              </div>
            </div>

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cyan/5 blur-3xl pointer-events-none" data-id="element-118" />
          </div>
        </div>
      </section>

      {/* Modals */}
      <ProjectModal isOpen={isProjectModalOpen} onClose={() => setIsProjectModalOpen(false)} data-id="element-119" />
      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} data-id="element-120" />
    </>;
}